'use client'

import Image from 'next/image'
import Link from 'next/link'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Autoplay from 'embla-carousel-autoplay'
import { ArrowRight, Star } from 'lucide-react'
import { useTranslations } from 'next-intl'

interface Review {
  id: number
  author: string
  avatarUrl?: string
  rating: number
  title: string
  productName: string
  productUrl: string
  content: string
  reviewedIn: string
  reviewDate: string
  amazonUrl: string
}

export const AmazonReviewSection = () => {
  const t = useTranslations('ldp_amazon_hardcode.review')
  return (
    <div className='bg-white py-10 md:py-16 2xl:py-20'>
      <div>
        <h2 className='text-center font-criteria text-2xl font-semibold uppercase text-neutral-800 md:text-3xl 2xl:text-4xl'>
          {t('title')}
        </h2>

        <Carousel
          opts={{
            loop: true,
            align: 'start',
          }}
          plugins={[
            Autoplay({
              delay: 4000,
              stopOnInteraction: false,
            }),
          ]}
          className='mx-5 mt-4 md:mx-15 md:mt-12'
        >
          <CarouselContent>
            {reviews.map((review) => (
              <CarouselItem
                key={review.id}
                className='basis-full cursor-grab py-4 md:basis-1/3 lg:pl-5 2xl:basis-1/4'
              >
                <div className='flex h-full flex-col justify-between rounded-2xl bg-white p-6 shadow-[0px_1px_4px_0px_rgba(0,0,0,0.08),0px_0px_24px_0px_rgba(0,0,0,0.06)]'>
                  <div>
                    <div className='flex items-center gap-3'>
                      <Image
                        src={ImageHelper.getImageUrl(review.avatarUrl ?? '')}
                        alt={review.author}
                        width={40}
                        height={40}
                        className='size-10 rounded-full bg-neutral-100 object-cover'
                      />
                      <p className='text-xl font-semibold text-black md:text-2xl'>
                        {review.author}
                      </p>
                    </div>

                    <div className='mt-4 flex items-center gap-2'>
                      <div className='flex gap-0.5'>
                        {[...Array(review.rating)].map((_, i) => (
                          <Star
                            key={i}
                            className='size-5 fill-yellow-400 text-yellow-400'
                          />
                        ))}
                      </div>
                      <p className='text-sm font-medium text-neutral-800'>
                        {review.title}
                      </p>
                    </div>

                    <p className='mt-2 text-sm text-neutral-600 md:text-base'>
                      Product:{' '}
                      <Link
                        href={review.productUrl}
                        className='text-primary-500 hover:underline'
                      >
                        {review.productName}
                      </Link>
                    </p>

                    <p className='mt-2 text-sm text-neutral-800 md:mt-4 md:text-base'>
                      {review.content}
                    </p>
                  </div>

                  <div className='mt-6 flex items-center justify-between'>
                    <p className='text-xs text-neutral-500'>
                      Reviewed in {review.reviewedIn}{' '}
                      <br className='md:hidden' /> on {review.reviewDate}
                    </p>
                    <Link
                      href={review.amazonUrl}
                      className='flex items-center gap-1 text-sm font-medium text-primary-500 hover:underline'
                    >
                      Amazon
                      <ArrowRight className='h-3 w-3' />
                    </Link>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselNavigation />
        </Carousel>
      </div>
    </div>
  )
}

const reviews: Review[] = [
  {
    id: 1,
    author: 'Mariella Ferreira',
    avatarUrl: '/image/October2025/mceclip11.png',
    rating: 5,
    title: 'Good gripping socks',
    productName: 'CoolMate 2/4 Pairs Pilates Socks',
    productUrl: '#',
    content:
      'Great for my reformer pilates classes! They are comfortable and the colors match the photo!',
    reviewedIn: 'the United States',
    reviewDate: 'September 16, 2025',
    amazonUrl:
      'https://www.amazon.com/COOLMATE-Pilates-Workout-Numeric-Regular/dp/B0DP6D7PSF?ref_=ast_sto_dp&th=1&psc=1',
  },
  {
    id: 2,
    author: 'D. Sim',
    avatarUrl: '/image/October2025/mceclip12.png',
    rating: 5,
    title: 'Great Pilates socks',
    productName: 'CoolMate 2/4 Pairs Pilates Socks',
    productUrl: '#',
    content:
      "Use them every day for Pilates. Grip works well and crew length make sure they don't fall off. Would buy them again",
    reviewedIn: 'the United States',
    reviewDate: 'July 11, 2025',
    amazonUrl:
      'https://www.amazon.com/COOLMATE-Pilates-Workout-Numeric-Regular/dp/B0DP6FDBXC?ref_=ast_sto_dp&th=1&psc=1',
  },
  {
    id: 3,
    author: 'Glorimar Zuniga',
    avatarUrl: '/image/October2025/mceclip13.png',
    rating: 5,
    title: 'Quality',
    productName: 'CoolMate 2/4 Pairs Pilates Socks',
    productUrl: '#',
    content:
      "They are very good for some workout when you don't want to wear your workout shoes. The best part is that you don't slide it has a good grip system in the bottom.",
    reviewedIn: 'the United States',
    reviewDate: 'September 16, 2025',
    amazonUrl:
      'https://www.amazon.com/COOLMATE-Pilates-Workout-Numeric-Regular/dp/B0DP6D7PSF?ref_=ast_sto_dp&th=1&psc=1',
  },
  {
    id: 4,
    author: 'Patricia Moore',
    avatarUrl: '/image/October2025/mceclip12.png',
    rating: 5,
    title: 'Comfortable Soft Material',
    productName: 'CoolMate Pilates Socks',
    productUrl: '#',
    content:
      'Grea comfort. Material is soft and i love how they snug your feet',
    reviewedIn: 'the United States',
    reviewDate: 'September 14, 2025',
    amazonUrl:
      'https://www.amazon.com/COOLMATE-Pilates-Workout-Numeric-Regular/dp/B0DP6FDBXC?ref_=ast_sto_dp&th=1&psc=1',
  },
  {
    id: 5,
    author: 'P. Hooke',
    avatarUrl: '/image/October2025/mceclip12.png',
    rating: 5,
    title: 'Great fit and comfort',
    productName: 'CoolMate 2/4 Pairs Pilates Socks',
    productUrl: '#',
    content:
      'These socks work great and fit nicely as well, they are comfortable.',
    reviewedIn: 'the United States',
    reviewDate: 'August 27, 2025',
    amazonUrl:
      'https://www.amazon.com/COOLMATE-Pilates-Workout-Numeric-Regular/dp/B0DP6D7PSF?ref_=ast_sto_dp&th=1&psc=1',
  },
  {
    id: 6,
    author: 'Iod',
    avatarUrl: '/image/October2025/mceclip12.png',
    rating: 5,
    title: 'Nice socks',
    productName: 'CoolMate 2/4 Pairs Pilates Socks',
    productUrl: '#',
    content: 'Love this socks for barre class, comfortable and stay in place',
    reviewedIn: 'the United States',
    reviewDate: 'September 1, 2025',
    amazonUrl:
      'https://www.amazon.com/COOLMATE-Pilates-Workout-Numeric-Regular/dp/B0DP6D7PSF?ref_=ast_sto_dp&th=1&psc=1',
  },
]

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-4 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute -right-4 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
